/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

export class LoggerService {

  log(...args: any[]) {
    console.log.apply(console, args);
  }

  info(...args: any[]) {
    console.info.apply(console, args);
  }

  error(...args: any[]) {
    console.error.apply(console, args);
  }

  count(arg: string) {
    console.count(arg);
  }

  group(arg: string) {
    console.count(arg);
  }

  groupEnd() {
    console.groupEnd();
  }

  profile(arg: string) {
    console.count(arg);
  }

  profileEnd() {
    console.profileEnd();
  }
}
